// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BackgroundItem__container-ccd54f:hover .BackgroundItem__remove-ee09c7 {
  opacity: 1;
}

.BackgroundItem__background-e0cdb4 {
  border-radius: 16px;
  overflow: hidden;
}

.BackgroundItem__remove-ee09c7 {
  position: absolute;
  top: 8px;
  inset-inline-end: 8px;
  z-index: 2 !important;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.BackgroundItem__remove-icon-ae0720 {
  fill: var(--addition-50);
}

.BackgroundItem__overlay-c7f7ba {
  position: absolute;
  box-shadow: inset 0px 0px 0px 1px var(--addition-50_10);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 16px;
  box-sizing: border-box;
  z-index: 1;
}

.BackgroundItem__overlay-c7f7ba * {
  display: none;
}

.BackgroundItem__active-a7b687 .BackgroundItem__overlay-c7f7ba {
  box-shadow: unset;
  border: 2px solid var(--brand-primary-40);
}

.BackgroundItem__active-a7b687 .BackgroundItem__overlay-c7f7ba * {
  display: block;
}

.BackgroundItem__border-e9aef9 {
  width: 100%;
  height: 100%;
  border: 2px solid var(--base-10);
  border-radius: 14px;
  box-sizing: border-box;
}

.BackgroundItem__shadow-fce6ae {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  box-shadow: inset 0px 0px 0px 1px var(--addition-50_10);
  box-sizing: border-box;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/components/Appearance/ChatBackgroundSelection/BackgroundItem/BackgroundItem.styles.m.css"],"names":[],"mappings":"AAAA;EACE,UAAA;AACF;;AAEA;EACE,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,qBAAA;EACA,UAAA;EACA,6BAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,kBAAA;EACA,uDAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,UAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,iBAAA;EACA,yCAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,gCAAA;EACA,mBAAA;EACA,sBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uDAAA;EACA,sBAAA;AACF","sourcesContent":[".container:hover .remove {\n  opacity: 1;\n}\n\n.background {\n  border-radius: 16px;\n  overflow: hidden;\n}\n\n.remove {\n  position: absolute;\n  top: 8px;\n  inset-inline-end: 8px;\n  z-index: 2 !important;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.remove-icon {\n  fill: var(--addition-50);\n}\n\n.overlay {\n  position: absolute;\n  box-shadow: inset 0px 0px 0px 1px var(--addition-50_10);\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 16px;\n  box-sizing: border-box;\n  z-index: 1;\n}\n\n.overlay * {\n  display: none;\n}\n\n.active .overlay {\n  box-shadow: unset;\n  border: 2px solid var(--brand-primary-40);\n}\n\n.active .overlay * {\n  display: block;\n}\n\n.border {\n  width: 100%;\n  height: 100%;\n  border: 2px solid var(--base-10);\n  border-radius: 14px;\n  box-sizing: border-box;\n}\n\n.shadow {\n  width: 100%;\n  height: 100%;\n  border-radius: 12px;\n  box-shadow: inset 0px 0px 0px 1px var(--addition-50_10);\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `BackgroundItem__container-ccd54f`,
	"remove": `BackgroundItem__remove-ee09c7`,
	"background": `BackgroundItem__background-e0cdb4`,
	"remove-icon": `BackgroundItem__remove-icon-ae0720`,
	"removeIcon": `BackgroundItem__remove-icon-ae0720`,
	"overlay": `BackgroundItem__overlay-c7f7ba`,
	"active": `BackgroundItem__active-a7b687`,
	"border": `BackgroundItem__border-e9aef9`,
	"shadow": `BackgroundItem__shadow-fce6ae`
};
module.exports = ___CSS_LOADER_EXPORT___;
